import { render } from "./WishPurchase.vue?vue&type=template&id=1b98614e&scoped=true"
import script from "./WishPurchase.vue?vue&type=script&lang=js"
export * from "./WishPurchase.vue?vue&type=script&lang=js"

import "./WishPurchase.vue?vue&type=style&index=0&id=1b98614e&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b98614e"]])

export default __exports__